import type { KeyboardEvent } from 'react'
import { formatCurrency, formatDate } from '@dcp/shared'
import type { ProjectionRecord } from '@/lib/projection-cell'

/** Accessible name of a saved row's selection checkbox. */
export function selectRowLabel(record: ProjectionRecord): string {
  const description = record.description?.trim()
  if (description) return `Select ${description}`
  // Date and amount tell apart rows that have no description to name them by.
  const amount = formatCurrency(record.amount, { negativeStyle: 'parentheses' })
  return `Select projection of ${amount} on ${formatDate(record.date)}`
}

/**
 * Row `onKeyDown` of a row in edit mode: Enter in a text field applies the row.
 * Only from an <input>: in an open Select or calendar (React bubbles through
 * portals) Enter picks an option.
 */
export function applyOnEnter(saving: boolean, onApply: () => void) {
  return (event: KeyboardEvent<HTMLTableRowElement>) => {
    if (event.key !== 'Enter' || event.nativeEvent.isComposing) return
    if (!(event.target instanceof HTMLInputElement) || saving) return
    event.preventDefault()
    onApply()
  }
}
